<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: ObjectBaseComponent template for LogicFlowStep entity — step-type-specific configuration sections (LOGIC_EXECUTE, CONDITION_BRANCH, SUB_FLOW, MAPPING_LOOKUP, ENTITY_SEARCH, etc.)
-->

@if (initialized && dto) {
    <div class="p-3">
        <!-- Step header with type badge -->
        <div class="flex align-items-center gap-2 mb-3">
            <i [class]="stepTypeIcon + ' text-xl text-primary'"></i>
            <span class="text-lg font-semibold">{{ dto.name }}</span>
            <p-tag [value]="stepTypeLabel" severity="info" class="ml-auto"></p-tag>
        </div>

        <!-- Generic CRUD form for common fields -->
        <!-- AI: CRUD Object Component for LogicFlowStep editing -->
        <mvs-crud-object
            [objectType]="'lg.LogicFlowStep'"
            [objectId]="objectIdentifier.objectId"
            (onChangedObject)="refreshObject(false)">
        </mvs-crud-object>

        <!-- ================================================================ -->
        <!-- Step-Type-Specific Configuration Sections                        -->
        <!-- ================================================================ -->

        <!-- ENTITY_SEARCH configuration -->
        @if (dto.stepType === LogicFlowStepTypeEnum.ENTITY_SEARCH) {
            <div class="mt-4 p-3 border-1 border-round surface-border">
                <div class="flex align-items-center gap-2 mb-3">
                    <i class="fa-regular fa-magnifying-glass text-primary"></i>
                    <span class="font-semibold">Entity-Suche Konfiguration</span>
                </div>

                <!-- SearchStrategy picker -->
                <div class="flex flex-column gap-2 mb-3">
                    <label class="font-medium text-sm">Suchstrategie</label>
                    @if (dto.searchStrategyDtoId) {
                        <div class="flex align-items-center gap-2">
                            <p-tag [value]="dto.searchStrategyDtoName" icon="fa-regular fa-magnifying-glass"></p-tag>
                            <p-button icon="fa-regular fa-xmark"
                                      [text]="true"
                                      severity="danger"
                                      size="small"
                                      pTooltip="Suchstrategie entfernen"
                                      (onClick)="onSearchStrategyClear()">
                            </p-button>
                        </div>
                    } @else {
                        <p-autoComplete
                            [suggestions]="searchStrategySuggestions"
                            (completeMethod)="searchSearchStrategies($event)"
                            (onSelect)="onSearchStrategySelect($event)"
                            field="name"
                            placeholder="Suchstrategie auswählen..."
                            [minLength]="1"
                            [forceSelection]="true"
                            styleClass="w-full">
                        </p-autoComplete>
                    }
                </div>

                <!-- Result variable -->
                <div class="flex flex-column gap-2">
                    <label class="font-medium text-sm">Ergebnis-Variable</label>
                    <input pInputText
                           type="text"
                           [ngModel]="dto.searchStrategyResultVariable"
                           (ngModelChange)="onResultVariableChange($event)"
                           placeholder="$searchResult"
                           class="w-full" />
                </div>
            </div>
        }

        <!-- Step Bindings -->
        @if (bindingWidget) {
            <div class="mt-4">
                <mvs-widget [widgetData]="bindingWidget"></mvs-widget>
            </div>
        }
    </div>
}
